import React from 'react';
import { usePWA } from '../contexts/PWAContext';
import { useLanguage } from '../contexts/LanguageContext';

const InstallBanner = () => {
  const { showInstallPrompt, promptInstall, dismissInstallPrompt } = usePWA();
  const { t } = useLanguage();

  // Don't render if we shouldn't show the prompt
  if (!showInstallPrompt) {
    return null;
  }

  const handleInstall = async () => {
    const success = await promptInstall();
    if (!success) {
      // User declined, dismiss the banner
      dismissInstallPrompt();
    }
  };

  const handleDismiss = () => {
    dismissInstallPrompt();
  };

  return (
    <div className="install-banner" role="banner" aria-label={t('pwa.installTitle')}>
      <div className="install-banner-content">
        <div className="install-banner-icon" aria-hidden="true">🎲</div>
        <div className="install-banner-text">
          <strong>{t('pwa.installTitle')}</strong>
          <span>{t('pwa.installDescription')}</span>
        </div>
      </div>
      <div className="install-banner-actions">
        <button
          className="install-banner-dismiss"
          onClick={handleDismiss}
          aria-label={t('pwa.notNow')}
        >
          {t('pwa.notNow')}
        </button>
        <button
          className="install-banner-install"
          onClick={handleInstall}
        >
          {t('pwa.install')}
        </button>
      </div>
    </div>
  );
};

export default InstallBanner;
